import React, { useContext, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FileSaver from 'file-saver';
import { ModalContext } from '@/utils/contexts/ModalContext';

import { appActions } from "@/store/actions/app.actions";

import api from '@/services/api';
import Spinner from '@/views/components/Spinner/Spinner';

import DropFile from '@/views/components/DropFile/DropFile';

import styles from '@/views/components/Modal/ModalImportFinalVersion.module.scss';

const ModalImportFinalVersion = () => {
	const dispatch = useDispatch();
	const dict = useSelector((state) => state.app.dict);
	// configure react-dropzone
	const { closeModal, showModal, modalAdditionalInfo } = useContext(ModalContext);

	const [ option, setOption ] = useState('accept');

	const [ droppedFiles, setDroppedFiles ] = useState();

	const [ waitingForResponse, setWaitingForResponse ] = useState(false);
	const [ errors, setErrors ] = useState([]);

	const [ apiError, setApiError ] = useState();

	const importFile = () => {
		if (!droppedFiles || droppedFiles.length === 0) return;
		const formD = new FormData();
		formD.append("docx", droppedFiles[0]);
		const toSend = {};
		formD.append("json", JSON.stringify(toSend));
		setWaitingForResponse(true);
		api.put(`/texts/${modalAdditionalInfo.id}/final`, formD, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}).then(() => {
			dispatch(appActions.setModalInfo('reload'));
			if(modalAdditionalInfo.templateId){
				showModal({
					componentName: 'ModalCheckTemplateAfterSimplification',
					additionalInfo: {
						id: modalAdditionalInfo.id,
						templateId: modalAdditionalInfo.templateId,
					},
				});
			} else {
				closeModal();
			}
		}).catch(({ response }) => {
			if (response.status === 400) {
				if (response.data.errors.length > 0) {
					setErrors(response.data.errors.map(it =>
						it.code.length > 0 ? it.code.split(".").join('') : null,
					).filter(el => el));
				}
				setWaitingForResponse(false);
			}
		});
	};

	const downloadFile = () => {
		api.get(`letters/${modalAdditionalInfo.id}/simplified/docx`, { responseType: 'blob' })
			.then((response) => {
				let fileName = response.headers["content-disposition"].split("filename=")[1];
				fileName = fileName.replaceAll('"','');
				FileSaver.saveAs(response.data, fileName);
			});
	};

	const downloadAndImportFile = () => {
		api.get(`letters/${modalAdditionalInfo.id}/simplified/docx`, { responseType: 'blob' })
			.then((response) => {
				let fileName = response.headers["content-disposition"].split("filename=")[1].replaceAll('"','');
				const downloadedFile = new File([ response.data ], fileName, {type:"application/vnd.openxmlformats-officedocument.wordprocessingml.document"});
				const formD = new FormData();
				formD.append("docx", downloadedFile);
				const toSend = {};
				formD.append("json", JSON.stringify(toSend));
				setWaitingForResponse(true);
				api.put(`/texts/${modalAdditionalInfo.id}/final`, formD, {
					headers: {
						'Content-Type': 'multipart/form-data',
					},
				}).then(() => {
					dispatch(appActions.setModalInfo('reload'));
					if(modalAdditionalInfo.templateId){
						showModal({
							componentName: 'ModalCheckTemplateAfterSimplification',
							additionalInfo: {
								id: modalAdditionalInfo.id,
								templateId: modalAdditionalInfo.templateId,
							},
						});
					} else {
						closeModal();
					}
				});
			});
	};

	const finishButtonAction = () => {
		if (option === 'upload') {
			importFile();
		} else if (option === 'accept') {
			downloadAndImportFile();
		}
	};

	const isFinishButtonDisabled = () => {
		if (option === 'accept') { return false; }
		if (option === 'upload') {
			if (!droppedFiles || droppedFiles.length === 0) {
				return true;
			} else {
				return false;
			}
		}
		return true;
	};

	useEffect(() => {
		if (errors.length){
			setApiError(dict.addLetter.errors[errors[0]]);
		}
	}, [ errors ]);

	return (
		<div className='modal__content'>
			<div className={ styles['import-final-version'] }>

				{waitingForResponse && (
					<div className='addletter__spinner'>
						<Spinner wrapper />
					</div>
				)}
				<h3 className={ styles['import-final-version--title'] }>
					{dict.modals.importFinalVersion.importFinalVersion}
				</h3>

				<div className={ styles['import-final-version--description'] }>
					{dict.modals.importFinalVersion.description}
				</div>

				<div className={ styles['import-final-version__options-container'] }>
					<div className={ styles['import-final-version__options-container__option'] }>
						<div className={ styles['import-final-version__options-container__option--radio'] }>
							<input 
								type="radio"
								checked={ option === 'accept' }
								onClick={ () => { setOption('accept'); } }
							/>
						</div>
						<div className={ styles['import-final-version__options-container__option--content'] }>
							<div className={ styles['import-final-version--option-header'] }>{dict.modals.importFinalVersion.acceptWorkingVersion}</div>
							<div className={ styles['import-final-version--option-content'] }>{dict.modals.importFinalVersion.acceptWorkingVersionDescription}</div>
						</div>
					</div>
					<div className={ styles['import-final-version__options-container__option'] }>
						<div className={ styles['import-final-version__options-container__option--radio'] }>
							<input 
								type="radio"
								checked={ option === 'upload' }
								onClick={ () => { setOption('upload'); } }
							/>
						</div>
						<div className={ styles['import-final-version__options-container__option--content'] }>
							<div className={ styles['import-final-version--option-header'] }>{dict.modals.importFinalVersion.importFile}</div>
							<div className={ styles['import-final-version--option-content'] }>
								<span 
									className={ styles['import-final-version--download'] } 
									onClick={ () => downloadFile() }
								>{dict.modals.importFinalVersion.importFileDescription1}</span>
								{dict.modals.importFinalVersion.importFileDescription2}
							</div>
							<div className={ styles['import-final-version--fileselect'] }>
								<label>{dict.modals.importFinalVersion.addFile}<span style={ { color: "#5c5c5a" } }>{dict.addLetter.docx}</span></label>
								<DropFile
									disabled={ option !== 'upload' }
									acceptFileType={ {"application/vnd.openxmlformats-officedocument.wordprocessingml.document": [ '.docx' ]} }
									setDroppedFiles={ setDroppedFiles }
									droppedFiles={ droppedFiles }
									apiError={ apiError }
									setApiError={ setApiError }
								/>
							</div>
						</div>
					</div>
				</div>
				<section className={ styles['import-final-version--buttons'] }>
					<div
						className='button__std'
						onClick={
							closeModal
						}
					>
						{dict.cancel}
					</div>
					<div
						className={ `button__blue${ isFinishButtonDisabled() ? ' disabled' : ''}` }
						onClick={ finishButtonAction }
					>
						{dict.modals.importFinalVersion.finishSimplificationButton}
					</div>
				</section>
			</div>
		</div>
	);
};

export default ModalImportFinalVersion;